import { createPortal } from "react-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import styles from "../WorkoutAdminModal.module.css";
import Badge from "./Badge";

export default function DayVideosAssignmentModal({
  dayVideosAssignment,
  setDayVideosAssignment,
  setDemoExerciseItem,
}) {
  return createPortal(
        <div
          className={styles.innerOverlay}
          onClick={(e) => { if (e.target === e.currentTarget) setDayVideosAssignment(null); }}
        >
          <div
            className={`${styles.planModal} ${styles.planModalNarrow}`}
            role="dialog"
            aria-modal="true"
            aria-labelledby="wam-day-videos-title"
          >
            <div className={styles.planModalHeader}>
              <h3 id="wam-day-videos-title">
                Vídeos - {dayVideosAssignment.custom_name || dayVideosAssignment.workout_plan?.title || "Treino"}
              </h3>
              <button
                type="button"
                className={styles.planModalClose}
                onClick={() => setDayVideosAssignment(null)}
                aria-label="Fechar"
              >
                <FontAwesomeIcon icon={faXmark} />
              </button>
            </div>

            <div className={styles.simpleList}>
              {[...(dayVideosAssignment.items || [])]
                .sort((a, b) => (a.order_index ?? 0) - (b.order_index ?? 0))
                .map((item) => {
                  const sourceLabel =
                    item.demo_source === "student"
                      ? "Vídeo específico do aluno"
                      : item.demo_source === "professor"
                      ? "Vídeo do professor"
                      : item.exercise_item?.demo_url
                      ? "Vídeo padrão"
                      : "Sem vídeo cadastrado";
                  return (
                    <div className={styles.simpleRow} key={item.id}>
                      <div className={styles.simpleRowMain}>
                        <div className={styles.simpleRowTop}>
                          <strong>{item.exercise_item?.name || "Exercício"}</strong>
                          <Badge tone={item.demo_source ? "info" : "muted"}>{sourceLabel}</Badge>
                        </div>
                      </div>
                      <div className={styles.simpleRowActions}>
                        {item.exercise_item?.demo_url ? (
                          <button
                            type="button"
                            className={`${styles.wamBtn} ${styles.ghost}`}
                            onClick={() => setDemoExerciseItem(item.exercise_item)}
                          >
                            ▶ Ver vídeo
                          </button>
                        ) : (
                          <span className={styles.wamFieldHint}>-</span>
                        )}
                      </div>
                    </div>
                  );
                })}

              {!dayVideosAssignment.items?.length && (
                <div className={styles.wamEmpty}>Nenhum exercício neste treino.</div>
              )}
            </div>
          </div>
        </div>,
        document.body
      )
}
